import { Maybe, PriceListHighlights, ProductMedia } from 'src/types';
import { CurrentCampaign, PriceDisplay } from '../../types';

export interface IHighlightedOffersProps {
  productId: number;
  categoryId: string | undefined;
  highlights: PriceListHighlights;
  campaign: Maybe<CurrentCampaign> | undefined;
  priceDisplay: PriceDisplay;
  media: ProductMedia & { first?: string | null };
}

export enum HighlightedOfferType {
  Recommended,
  Cheapest,
  Fastest,
}
